// extracted by mini-css-extract-plugin
export default {"emptyWrapper":"TableRoutingList_emptyWrapper__jVyDQ","emptyTitle":"TableRoutingList_emptyTitle__hbjY+","emptyDescription":"TableRoutingList_emptyDescription__Cydz1"};